import React from 'react';
import Table from '../../../../../components/_table/Table/Table';
import Panel from '../../../../../components/outline/Panel';
import { columns } from './columns';
import Button from '../../../../../components/Button';
import { reDirectPage } from '../../../../../lib/common';
import { POINT_CAUSE_CREATE_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import './PointCauseList.scss';

const PointCauseList = (props) => {
  const { pointCauseList, getList, initialOption, pagination } = props;

  return (
    <div className="point-cause-list">
      <Panel>
        <div className="panel-body">
          <Button
            isRadius
            color="primary"
            text="등록하기"
            onClick={() => reDirectPage({ path: POINT_CAUSE_CREATE_URL_PATH })}
          />

          <Table
            columns={columns}
            rowKey={(record) => record.id}
            list={pointCauseList}
            initialOption={initialOption}
            pagination={pagination}
            size="small"
            scroll={{ x: true }}
            bordered={true}
            getList={getList}
          />
        </div>
      </Panel>
    </div>
  );
};

export default PointCauseList;
